import React from "react";

import {ButtonBackToList} from "../../app/components/ButtonCollection";

export const RenderBackToListButton = React.memo(() => {
    return <ButtonBackToList name={'venues.index'} />;
});
RenderBackToListButton.displayName = 'RenderBackToListButton';
